import React,{useEffect,useState,useRef,useCallback} from "react";
import {Link} from 'react-router-dom'
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import * as XLSX from 'xlsx/xlsx.mjs';
import { Oval } from  'react-loader-spinner'
import axios from 'axios'
import _ from 'lodash'
import $ from 'jquery';



const pageSize = 10;


const TcTransactionmain = () => {

  const[pop,setpop] = useState(true);
  const[history,setHistory] = useState([]);
  const[pendinghistory,setPendingHistory] = useState([]);
 const [pendingdata,setPendingdata] = useState(false)

  const [allusers,setAllusers]= useState([])  
    //const [currentPage, setcurrentPage] = useState(1);






  useEffect(()=>{

    GetTransactionhistory();
    Btnhide();
    
 
  },[])


function Btnhide(){
  document.getElementById('pendingBtn').style.display = "none";
  document.getElementById('completedBtn').style.display = "none";

  document.getElementById('Pendingbtntable').style.display = "none";
  document.getElementById('Completebtntable').style.display = "none";
  
   document.getElementById('Tc-transactionbtn').style.display = "none";
   document.getElementById('Tc-completebtn').style.display = "none";

   document.getElementById('pagination').style.display = "none";

 
}
  /*--- pending table---*/

  function displaypendingtable(){
    document.getElementById('pendingBtn').style.background= "rgb(19, 58, 98)"
    document.getElementById('completedBtn').style.background = "linear-gradient( #fe9347, #ff6a00)"
    document.getElementById('Completebtntable').style.display = "none";
    document.getElementById('Tc-completebtn').style.display = "none";
    document.getElementById('pagination').style.display = "none";

      document.getElementById('Pendingbtntable').style.display = "flex";
    document.getElementById('Tc-transactionbtn').style.display = "flex";
 

  }

   /*--- completed table---*/

 function displaycompletetable(){
  
  document.getElementById('completedBtn').style.background= "rgb(19, 58, 98)"
    document.getElementById('pendingBtn').style.background = "linear-gradient( #fe9347, #ff6a00)"
      document.getElementById('Completebtntable').style.display = "flex";
      document.getElementById('Tc-completebtn').style.display = "flex";

      document.getElementById('Pendingbtntable').style.display = "none";
      document.getElementById('Tc-transactionbtn').style.display = "none";
      
      document.getElementById('pagination').style.display = "block";
 }

  /*--- submit btn function ---*/

function buttondisplay(){
  
  document.getElementById('form').style.display = "none"; 
   document.getElementById('pendingBtn').style.display = "block";
   document.getElementById('completedBtn').style.display = "block";
}

function handlechange(){
  var name = document.getElementById('user').value;
  var password = document.getElementById('password').value;
    
  if(!name){
    document.getElementById("nameerror").innerHTML = "Name Required";
  }
  else{
    document.getElementById("nameerror").innerHTML = "";
  }
   if(!password){
    document.getElementById("pswerror").innerHTML = "Password Required";
  }
  else{
  document.getElementById("pswerror").innerHTML = "";
}
}


function login(e){

   e.preventDefault();

var name = document.getElementById('user').value;
var password = document.getElementById('password').value;
  
if(!name){
  document.getElementById("nameerror").innerHTML = "Name Required";
}
else{
  document.getElementById("nameerror").innerHTML = "";
}
 if(!password){
  document.getElementById("pswerror").innerHTML = "Password Required";
}
else{
document.getElementById("pswerror").innerHTML = "";


    let body={
      username:document.getElementById('user').value,
      password:document.getElementById('password').value,
      OSX_Platform:"A",
      Version:"1.0.71",
    Device_Id:"NoTokenForAdmin",
  };
     console.log(body)
     
  let username = document.getElementById('user').value
       
    if(username!=="6381061700"){
document.getElementById('nameerror-notify').style.display = "block"
          setTimeout(()=>{
            document.getElementById('nameerror-notify').style.display = "none"
          },1000)
}   
else if(password!=="Dhinesh@123"){
document.getElementById('pswerror-notify').style.display = "block"
          setTimeout(()=>{
            document.getElementById('pswerror-notify').style.display = "none"
          },1000)
}
    else{ 
      
     document.getElementById('success-notify').style.display = "block"
          setTimeout(()=>{
          document.getElementById('success-notify').style.display = "none"
        },1000)
      
       axios({
        method: "POST",
      
        url:'https://tclapi.thatscool.in/api/Authenticate/login',
        data:body,
        headers: {
          "Content-Type": "application/json"
        }
      })   
        .then((response) =>{
        console.log(response.data);
        // setpop(true);
        // setTimeout(()=>{
        //   setpop(false);
        //buttondisplay()
        // },1000)
     
        buttondisplay()  
        })   
        .catch(error => {
          console.log(error);
          document.getElementById('error-notify').style.display = "block"
          setTimeout(()=>{
            document.getElementById('error-notify').style.display = "none"
          },1000)
         document.getElementById('user').value=""
      document.getElementById('password').value=""
        })
   
        }
        
      }
      
  }


 

/*--- pending download btn---*/

  function downloadpendingPdf(){
   
    
 var pdf = new jsPDF();
 
 pdf.autoTable({html:'#TcpendingTable'});

 pdf.save('TcpendingTable.pdf');
 
}

const tableRef = useRef(null);
 

function downloadpendingExcel(){
  
 
// let demo= document.getElementById("tbody")
//  console.log(demo)
// demo.remove(demo.innerText =="")
    

  const table = tableRef.current;
  const rows = table.querySelectorAll("tr");
  const data = [];

  for (let i = 0; i < rows.length; i++) {
    const cols = rows[i].querySelectorAll("td");
    const rowData = [];

    for (let j = 0; j < cols.length; j++) {
      const value = cols[j].textContent.trim();

      if (value) {
        rowData.push(value);
      }
    }

    if (rowData.length > 0) {
      data.push(rowData);
    }
  }

  // create a worksheet object
  const sheet = XLSX.utils.aoa_to_sheet(data);

  // create a workbook object and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");

  // generate the Excel file
  XLSX.writeFile(workbook, "pendingTransactionTable.xlsx");



  // var table = document.getElementById("TcpendingTable"); 
  // console.log(table)
 
  // var workbook = XLSX.utils.table_to_book(table);
   
  // XLSX.writeFile(workbook, "pendingTransactionTable.xlsx");

  // console.log(workbook);
  
 
 }
 


 /*--- complete download btn---*/

 function downloadcompletePdf(){
   
  var pdf = new jsPDF();
  
  pdf.autoTable({html:'#TccompleteTable'});
 
  pdf.save('TccompleteTable.pdf');
  
 }
 
 function downloadcompleteExcel(){

 
   var table = document.getElementById("Completebtntable"); 
   console.log(table)

   var workbook = XLSX.utils.table_to_book(table);
    
   XLSX.writeFile(workbook, "completeTransactionTable.xlsx");
 
   console.log(workbook);
     
  }

  
  
 {/* ---  get pending table Details--- */}

  function GetTransactionhistory(){
     
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

    fetch('https://tclapi.thatscool.in/api/Admin/Total_TransactionHistory', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
        'Authorization':bearer 
      },
  
    
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
  localStorage.setItem("transData", JSON.stringify(data));

setHistory(_(data).slice(0).take(pageSize).value())
 setAllusers(data)
 setPendingHistory(data)

  });

  }

  



  // function checkAdult(value) {
  //   return value !=="null";
  // }

  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
  // // if (pageCount === 1)
  // // return null;
  
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
 
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo - 1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setHistory(paginatedPost)
  // }


  function Tctranshide(){

    var x = document.getElementById("password");
  
    var eye = document.getElementById("eye-loginform");
  
    if(x.type === "password"){
   x.type = "text";
      eye.classList.remove("fa-eye-slash")
      eye.classList.add("fa-eye")
     
   }
    else{
      x.type = "password";
      eye.classList.remove("fa-eye")
      eye.classList.add("fa-eye-slash")
  
    }
   }


   const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

const [currentPage, setCurrentPage] = useState(1);

let data = localStorage.getItem("transData")
let transdata =  JSON.parse(data);
let NUM_OF_RECORDS = transdata.length;
let LIMIT = 10;

const onPageChanged = useCallback(

  (event, page) => {
    event.preventDefault();
    setCurrentPage(page);
  },
  [setCurrentPage]
  
);


const currentData = transdata.slice(
  (currentPage - 1) * LIMIT,
  (currentPage - 1) * LIMIT + LIMIT
);

const Paginations = (props) => {
  const {
    totalRecords,
    pageLimit,
    pageNeighbours,
    onPageChanged,
    currentPage
  } = props;
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    setTotalPages(Math.ceil(totalRecords / pageLimit));
  }, [setTotalPages]);

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    
  
    const totalBlocks = totalNumbers + 2;
   

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

      let pages = range(startPage, endPage);

      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }
        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }
      return [1, ...pages, totalPages];
    }
    return range(1, totalPages);
  };


  const pages = fetchPageNumbers() || [];
  return (
    <nav aria-label="Countries Pagination">
      <ul className="pagination">
        {pages.map((page, index) => {
          if (page === LEFT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  href="/"
                  className="page-link"
                  aria-label="Previous"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
            );

          if (page === RIGHT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  className="page-link"
                  href="/"
                  aria-label="Next"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            );

          return (
            <li
              key={index}
              className={`Tc-page-item${currentPage === page ? " active" : ""}`}
            >
              <a
                className="page-link"
                href="/"
                onClick={(e) => onPageChanged(e, page)}
              >
                {page}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
  
return(
    <>
 
        <div className='TC-addmain'>   
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Transaction </span>
    </div>
    </div>
    <div className='Tc-TransactionMain' id='Tc-sectionMain'>
      <button className="winnerBtn" id="pendingBtn" onClick={displaypendingtable}>Pending</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button  className="winnerBtn"  id="completedBtn"onClick={displaycompletetable}>Completed</button>

      <div class="wrapper fadeInDown" id="form">      
  <div id="transactionform">
      <form className='TransactionForm'>
 <input type="text" id="user"  name="name"  placeholder="UserName" onKeyUp={handlechange}></input>
 <span id="nameerror" className="Transaction-error"></span>
 
  <input type="password" id="password" name="psw"   placeholder="Password" onKeyUp={handlechange}></input>
  <span id="pswerror" className="Transaction-error"></span>
  <i class="fa fa-eye-slash" aria-hidden="true" onClick={Tctranshide} id="eye-loginform"></i>

<div className='btn-div'>
  <button type='submit' className="fadeIn fourth" onClick={login}>Submit </button>     
  </div>

</form>

    </div>
    </div>  
    </div> 

    {/* --- pending table--- */}

    <div className='TCtable' id='Pendingbtntable'>
     <div class="TC-table_responsive" >
     {/* {
  !history ? (""):(  */}
       <table  className='TC-tblhead' id='TcpendingTable' ref={tableRef} > 
    <thead>
   <tr>
 <td style={{fontWeight: "bold"}}>Transaction Id</td>
<td style={{fontWeight: "bold"}}>Name</td>
 <td style={{fontWeight: "bold"}}>Req.Amt</td>
<td style={{fontWeight: "bold"}}>Transaction Type</td>
<td style={{fontWeight: "bold"}}>Bank Acc.No</td>
<td style={{fontWeight: "bold"}}>IFSC Code</td>
<td style={{fontWeight: "bold"}}>UPI Id</td>
<td style={{fontWeight: "bold"}}>Created Date</td> 


</tr>
</thead>
<tbody>
{pendinghistory.map((e)=>
{
return<tr id="tbody">


  {e.Transaction_Flag==2?<td>{e.Transaction_Id==null?'-':e.Transaction_Id}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Bank_HolderName==null?'-':e.Bank_HolderName}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Req_Amount==null?'-':e.Req_Amount}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Bank_AcNo==null?"Online Transaction":"Bank Transaction"}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Bank_AcNo==null?'-':e.Bank_AcNo}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Bank_IFSC_Code==null?'-':e.Bank_IFSC_Code}</td>:null}
  {e.Transaction_Flag==2?<td>{e.UPI_Id==null?'-':e.UPI_Id}</td>:null}
  {e.Transaction_Flag==2?<td>{e.Transation_Time==null?'-':e.Transation_Time.slice(0,10)}</td>:null} 
  
</tr>
 })} 
</tbody>

</table>

  {/* )}
<br></br>
<nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}  >
          
            {page}
            </p>
            </li>
        ))
      }
       
    </ul>
  </nav>   */}
     </div>
  </div>
  <div className='Tc-TransactionMain' id='Tc-transactionbtn'>
  <button id='TCdownloadbtn' onClick={downloadpendingPdf}>Download as PDF</button>  &nbsp; &nbsp;&nbsp; &nbsp;
     <button id='TCdownloadbtn'onClick={downloadpendingExcel} >Download as Excel</button> 
     </div>

     

  {/* --- completed table--- */}

     <div className='TCtable' id='Completebtntable'>
     <div class="TC-table_responsive">
     {/* {
  !history ? (""):(  */}
       <table  className='TC-tblhead' id='TccompleteTable'> 
    <thead>
   <tr>
   <th>Transaction Id</th>
<th>Name</th>
 <th>Req.Amt</th>
 <th>Transaction Type</th>
<th>Bank Acc.No</th>
<th>IFSC Code</th>
<th>UPI Id</th>
<th>Created Date</th>
</tr>
</thead>
<tbody>
{currentData.map((e)=>
{
return<tr>
{e.Transaction_Flag==1?<td>{e.Transaction_Id==null?'-':e.Transaction_Id}</td>:null}
{e.Transaction_Flag==1?<td>{e.Bank_HolderName==null?'-':e.Bank_HolderName}</td>:null}
  {e.Transaction_Flag==1?<td>{e.Req_Amount==null?'-':e.Req_Amount}</td>:null}
  {e.Transaction_Flag==1?<td>{e.Bank_AcNo==null?"Online Transaction":"Bank Transaction"}</td>:null}
  {e.Transaction_Flag==1?<td>{e.Bank_AcNo==null?'-':e.Bank_AcNo}</td>:null}
  {e.Transaction_Flag==1?<td>{e.Bank_IFSC_Code==null?'-':e.Bank_IFSC_Code}</td>:null}
  {e.Transaction_Flag==1?<td>{e.UPI_Id==null?'-':e.UPI_Id}</td>:null}
  {e.Transaction_Flag==1?<td>{e.Transation_Time==null?'-':e.Transation_Time.slice(0,10)}</td>:null} 


</tr>
 })} 
</tbody>

</table>
{/* )} */}

     </div>
  </div>
  <br></br>

  <div id="pagination">

  {transdata.length<=5 ? null: <nav id="Tc-Pag">
    <ul className='Tc-pagination'>
   
    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "Tc-page-item active" : "Tc-page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}  >
          
            {page}
            </p>
            </li>
        ))
      } */}
       

    </ul>
  </nav> }
 
  </div>
  <div className='Tc-TransactionMain' id='Tc-completebtn'>
  <button id='TCdownloadbtn' onClick={downloadcompletePdf}>Download as PDF</button>  &nbsp; &nbsp;&nbsp; &nbsp;
     <button id='TCdownloadbtn'onClick={downloadcompleteExcel} >Download as Excel</button> 
     </div>
   <br></br> 

   <div className='TCpopfade' id='nameerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title"> Incorrect Username</h6>
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='pswerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title">Incorrect Password</h6> 
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p></p>
             <h6 class="notif-title"> Login Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>


     {/* {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null} */}
    </div>

    </>
)
}

export default TcTransactionmain;